import React from 'react';
import { observer } from 'mobx-react';
import BillListService from '../services/BillListService';
import BillListFilter from './BillListFilter';
import PropTypes from 'prop-types';
import moment from 'moment';

class BillListFilterContainer extends React.Component {
  static propTypes = {
    initialFilters: PropTypes.object,
  };

  componentDidMount() {
    BillListService.init();
    if (this.props.initialFilters) {
      BillListService.form.setValue('documentNumber', this.props.initialFilters.documentNumber);
      BillListService.form.setValue('status', this.props.initialFilters.status);
      BillListService.form.setValue(
        'dueEnd',
        this.props.initialFilters.dueEnd && moment(this.props.initialFilters.dueEnd).utc()
      );
    }
    BillListService.load();
  }

  render() {
    return (
      <BillListFilter
        onChange={BillListService.form.setValue}
        values={BillListService.form.getValues()}
        onSearch={BillListService.load}
        onBillReportDownload={BillListService.downloadBillReport}
        fetching={BillListService.fetch.fetching}
      />
    );
  }
}

export default observer(BillListFilterContainer);
